"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpsellProducts = void 0;
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _useAppSelector = require("../useAppSelector");
const useUpsellProducts = () => {
  const selectedUpsellProducts = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSelectedUpsellProductOfferings);
  return {
    selectedUpsellProducts
  };
};
exports.useUpsellProducts = useUpsellProducts;